import { render } from "./RankingsTable.vue?vue&type=template&id=3704799b&scoped=true"
import script from "./RankingsTable.vue?vue&type=script&lang=js"
export * from "./RankingsTable.vue?vue&type=script&lang=js"

import "./RankingsTable.vue?vue&type=style&index=0&id=3704799b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3704799b"]])

export default __exports__